import { render, staticRenderFns } from "./RelatedProfiles.vue?vue&type=template&id=c9445a32&scoped=true"
import script from "./RelatedProfiles.vue?vue&type=script&lang=js"
export * from "./RelatedProfiles.vue?vue&type=script&lang=js"
import style0 from "./RelatedProfiles.vue?vue&type=style&index=0&id=c9445a32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9445a32",
  null
  
)

export default component.exports